import { render, staticRenderFns } from "./EmptyTableResult.vue?vue&type=template&id=27bf5f0b&"
import script from "./EmptyTableResult.vue?vue&type=script&lang=js&"
export * from "./EmptyTableResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports